import { createContext, useContext, useState, useCallback } from "react";

export const translations = {
  es: {
    "app.name": "ENESER",
    "app.tagline": "AI Publishing Studio",
    "landing.hero.badge": "Estudio editorial con Inteligencia Artificial",
    "landing.hero.title": "Escribe, diseña y publica tu libro con IA",
    "landing.hero.subtitle": "El estudio en la nube donde tu manuscrito cobra vida: escritura asistida, Book Bible, voz narrada y portadas con IA. Exporta a EPUB y PDF listos para publicar.",
    "landing.cta.start": "Empezar a escribir",
    "landing.cta.login": "Iniciar sesión",
    "landing.feat.write.t": "Escritura asistida",
    "landing.feat.write.d": "Expande, reescribe y corrige con Claude Sonnet 5 sin salir del editor.",
    "landing.feat.bible.t": "Book Bible",
    "landing.feat.bible.d": "Fichas de personajes, mundo y notas siempre a mano.",
    "landing.feat.voice.t": "Voz narrada",
    "landing.feat.voice.d": "Escucha tus capítulos con voces ElevenLabs de calidad estudio.",
    "landing.feat.cover.t": "Portadas con IA",
    "landing.feat.cover.d": "Genera portadas cinematográficas o sube la tuya propia.",
    "landing.feat.export.t": "Exporta EPUB / PDF",
    "landing.feat.export.d": "Descarga tu libro listo para e-readers e imprenta.",

    "auth.login.title": "Bienvenido de vuelta",
    "auth.register.title": "Crea tu estudio",
    "auth.login.subtitle": "Entra para continuar tu manuscrito",
    "auth.register.subtitle": "Empieza a escribir tu próximo libro hoy",
    "auth.name": "Nombre",
    "auth.email": "Email",
    "auth.password": "Contraseña",
    "auth.login.button": "Iniciar sesión",
    "auth.register.button": "Crear cuenta",
    "auth.toRegister": "¿No tienes cuenta? Regístrate",
    "auth.toLogin": "¿Ya tienes cuenta? Inicia sesión",

    "dash.title": "Mis proyectos",
    "dash.subtitle": "Tu biblioteca de manuscritos",
    "dash.new": "Nuevo libro",
    "dash.empty.title": "Aún no tienes libros",
    "dash.empty.sub": "Crea tu primer proyecto y empieza a escribir con ayuda de IA.",
    "dash.chapters": "capítulos",
    "dash.open": "Abrir estudio",
    "dash.logout": "Cerrar sesión",

    "modal.newbook.title": "Nuevo libro",
    "modal.field.title": "Título",
    "modal.field.subtitle": "Subtítulo",
    "modal.field.author": "Autor",
    "modal.field.language": "Idioma del libro",
    "modal.field.genre": "Género",
    "modal.field.description": "Sinopsis",
    "modal.create": "Crear libro",
    "modal.cancel": "Cancelar",
    "modal.save": "Guardar",
    "modal.delete": "Eliminar",
    "modal.deleteConfirm": "¿Eliminar este libro y todos sus capítulos?",

    "studio.chapters": "Capítulos",
    "studio.chapter": "Capítulo",
    "studio.bible": "Book Bible",
    "studio.cover": "Portada IA",
    "studio.export": "Exportar",
    "studio.settings": "Ajustes del libro",
    "studio.back": "Proyectos",
    "studio.addChapter": "Añadir capítulo",
    "studio.words": "palabras",
    "studio.chars": "caracteres",
    "studio.saving": "Guardando…",
    "studio.saved": "Guardado",
    "studio.titlePlaceholder": "Título del capítulo",
    "studio.contentPlaceholder": "Empieza a escribir tu historia aquí…",
    "fmt.bold": "Negrita",
    "fmt.italic": "Cursiva",
    "fmt.underline": "Subrayado",
    "fmt.h2": "Título",
    "fmt.h3": "Subtítulo",
    "fmt.paragraph": "Párrafo",
    "fmt.quote": "Cita",
    "fmt.list": "Lista",

    "ai.title": "Asistente IA",
    "ai.selectionHint": "Selecciona texto o usa todo el capítulo",
    "ai.expand": "Expandir",
    "ai.rewrite": "Reescribir",
    "ai.correct": "Corregir",
    "ai.continue": "Continuar",
    "ai.idea": "Ideas",
    "ai.tone": "Tono",
    "ai.working": "La IA está trabajando…",
    "ai.ideasTitle": "Ideas para tu historia",
    "ai.insert": "Insertar",
    "ai.replace": "Reemplazar selección",
    "ai.close": "Cerrar",
    "ai.toneInstruction": "Describe el tono (p. ej. más íntimo, más tenso)",

    "bible.add": "Añadir ficha",
    "bible.type.character": "Personaje",
    "bible.type.world": "Mundo",
    "bible.type.note": "Nota",
    "bible.all": "Todas",
    "bible.name": "Nombre",
    "bible.role": "Rol",
    "bible.traits": "Rasgos",
    "bible.relationships": "Relaciones",
    "bible.notes": "Notas",
    "bible.empty": "Sin fichas todavía. Añade personajes, lugares o notas de tu mundo.",

    "cover.title": "Generador de portada",
    "cover.tab.ai": "Generar con IA",
    "cover.tab.upload": "Subir la mía",
    "cover.prompt": "Describe tu portada",
    "cover.promptPlaceholder": "Un faro solitario bajo un cielo estrellado, tonos fríos, atmósfera melancólica…",
    "cover.style": "Estilo artístico",
    "cover.generate": "Generar portada",
    "cover.generating": "Creando tu portada…",
    "cover.apply": "Aplicar al libro",
    "cover.upload": "Arrastra o selecciona una imagen",
    "cover.style.editorial": "Minimalista Editorial",
    "cover.style.gothic": "Gótico Oscuro",
    "cover.style.fantasy": "Fantasía Épica",
    "cover.style.romance": "Romance",
    "cover.style.thriller": "Thriller",
    "cover.style.scifi": "Ciencia Ficción",
    "cover.overlay": "Maquetar título y autor",
    "cover.titleText": "Texto del título",
    "cover.authorText": "Texto del autor",
    "cover.position": "Posición del texto",
    "cover.pos.bottom": "Abajo",
    "cover.pos.top": "Arriba",
    "cover.pos.center": "Centro",
    "cover.tab.front": "Portada",
    "cover.tab.back": "Contraportada",
    "cover.synopsis": "Sinopsis (texto de contraportada)",
    "cover.synopsisPlaceholder": "Un relato sobre soledad y redención en la costa más remota…",
    "cover.applyBack": "Aplicar contraportada",
    "cover.backHint": "Se maqueta sobre la portada (si existe) o sobre un fondo editorial.",
    "cover.imprint": "ENESER · AI Publishing Studio",

    "audio.title": "Voz narrada",
    "audio.voice": "Voz",
    "audio.play": "Escuchar",
    "audio.generating": "Generando audio…",
    "audio.download": "Descargar MP3",
    "audio.notConfigured": "Añade tu API key de ElevenLabs para activar la voz.",
    "audio.limit": "Límite por acción",
    "audio.willUse": "Se narrará la selección o el inicio del capítulo",

    "export.title": "Exportar libro",
    "export.epub": "EPUB3 · e-Reader",
    "export.pdf": "PDF · Imprenta A5",
    "export.epubDesc": "Formato estándar para Kindle, Kobo y Apple Books.",
    "export.pdfDesc": "Maquetado A5 listo para imprenta o revisión.",
    "export.download": "Descargar",
    "export.preparing": "Preparando archivo…",

    "toast.saved": "Cambios guardados",
    "toast.aiDone": "Texto generado",
    "toast.coverApplied": "Portada aplicada",
    "toast.exported": "Libro exportado",
    "toast.error": "Ha ocurrido un error",
  },
  en: {
    "app.name": "ENESER",
    "app.tagline": "AI Publishing Studio",
    "landing.hero.badge": "AI-powered publishing studio",
    "landing.hero.title": "Write, design and publish your book with AI",
    "landing.hero.subtitle": "The cloud studio where your manuscript comes alive: assisted writing, Book Bible, narrated voice and AI covers. Export to EPUB and PDF ready to publish.",
    "landing.cta.start": "Start writing",
    "landing.cta.login": "Sign in",
    "landing.feat.write.t": "Assisted writing",
    "landing.feat.write.d": "Expand, rewrite and proofread with Claude Sonnet 5 right in the editor.",
    "landing.feat.bible.t": "Book Bible",
    "landing.feat.bible.d": "Character, world and note cards always at hand.",
    "landing.feat.voice.t": "Narrated voice",
    "landing.feat.voice.d": "Listen to your chapters with studio-grade ElevenLabs voices.",
    "landing.feat.cover.t": "AI covers",
    "landing.feat.cover.d": "Generate cinematic covers or upload your own.",
    "landing.feat.export.t": "Export EPUB / PDF",
    "landing.feat.export.d": "Download your book ready for e-readers and print.",

    "auth.login.title": "Welcome back",
    "auth.register.title": "Create your studio",
    "auth.login.subtitle": "Sign in to continue your manuscript",
    "auth.register.subtitle": "Start writing your next book today",
    "auth.name": "Name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.login.button": "Sign in",
    "auth.register.button": "Create account",
    "auth.toRegister": "No account? Sign up",
    "auth.toLogin": "Already have an account? Sign in",

    "dash.title": "My projects",
    "dash.subtitle": "Your manuscript library",
    "dash.new": "New book",
    "dash.empty.title": "No books yet",
    "dash.empty.sub": "Create your first project and start writing with AI.",
    "dash.chapters": "chapters",
    "dash.open": "Open studio",
    "dash.logout": "Log out",

    "modal.newbook.title": "New book",
    "modal.field.title": "Title",
    "modal.field.subtitle": "Subtitle",
    "modal.field.author": "Author",
    "modal.field.language": "Book language",
    "modal.field.genre": "Genre",
    "modal.field.description": "Synopsis",
    "modal.create": "Create book",
    "modal.cancel": "Cancel",
    "modal.save": "Save",
    "modal.delete": "Delete",
    "modal.deleteConfirm": "Delete this book and all its chapters?",

    "studio.chapters": "Chapters",
    "studio.chapter": "Chapter",
    "studio.bible": "Book Bible",
    "studio.cover": "AI Cover",
    "studio.export": "Export",
    "studio.settings": "Book settings",
    "studio.back": "Projects",
    "studio.addChapter": "Add chapter",
    "studio.words": "words",
    "studio.chars": "characters",
    "studio.saving": "Saving…",
    "studio.saved": "Saved",
    "studio.titlePlaceholder": "Chapter title",
    "studio.contentPlaceholder": "Start writing your story here…",
    "fmt.bold": "Bold",
    "fmt.italic": "Italic",
    "fmt.underline": "Underline",
    "fmt.h2": "Heading",
    "fmt.h3": "Subheading",
    "fmt.paragraph": "Paragraph",
    "fmt.quote": "Quote",
    "fmt.list": "List",

    "ai.title": "AI Assistant",
    "ai.selectionHint": "Select text or use the whole chapter",
    "ai.expand": "Expand",
    "ai.rewrite": "Rewrite",
    "ai.correct": "Proofread",
    "ai.continue": "Continue",
    "ai.idea": "Ideas",
    "ai.tone": "Tone",
    "ai.working": "AI is working…",
    "ai.ideasTitle": "Ideas for your story",
    "ai.insert": "Insert",
    "ai.replace": "Replace selection",
    "ai.close": "Close",
    "ai.toneInstruction": "Describe the tone (e.g. more intimate, more tense)",

    "bible.add": "Add card",
    "bible.type.character": "Character",
    "bible.type.world": "World",
    "bible.type.note": "Note",
    "bible.all": "All",
    "bible.name": "Name",
    "bible.role": "Role",
    "bible.traits": "Traits",
    "bible.relationships": "Relationships",
    "bible.notes": "Notes",
    "bible.empty": "No cards yet. Add characters, places or world notes.",

    "cover.title": "Cover generator",
    "cover.tab.ai": "Generate with AI",
    "cover.tab.upload": "Upload mine",
    "cover.prompt": "Describe your cover",
    "cover.promptPlaceholder": "A lonely lighthouse under a starry sky, cool tones, melancholic atmosphere…",
    "cover.style": "Art style",
    "cover.generate": "Generate cover",
    "cover.generating": "Creating your cover…",
    "cover.apply": "Apply to book",
    "cover.upload": "Drag or select an image",
    "cover.style.editorial": "Minimalist Editorial",
    "cover.style.gothic": "Dark Gothic",
    "cover.style.fantasy": "Epic Fantasy",
    "cover.style.romance": "Romance",
    "cover.style.thriller": "Thriller",
    "cover.style.scifi": "Science Fiction",
    "cover.overlay": "Lay out title & author",
    "cover.titleText": "Title text",
    "cover.authorText": "Author text",
    "cover.position": "Text position",
    "cover.pos.bottom": "Bottom",
    "cover.pos.top": "Top",
    "cover.pos.center": "Center",
    "cover.tab.front": "Front cover",
    "cover.tab.back": "Back cover",
    "cover.synopsis": "Synopsis (back cover text)",
    "cover.synopsisPlaceholder": "A story about solitude and redemption on the remotest coast…",
    "cover.applyBack": "Apply back cover",
    "cover.backHint": "Laid out over the front cover (if any) or an editorial background.",
    "cover.imprint": "ENESER · AI Publishing Studio",

    "audio.title": "Narrated voice",
    "audio.voice": "Voice",
    "audio.play": "Listen",
    "audio.generating": "Generating audio…",
    "audio.download": "Download MP3",
    "audio.notConfigured": "Add your ElevenLabs API key to enable voice.",
    "audio.limit": "Per-action limit",
    "audio.willUse": "Your selection or the start of the chapter will be narrated",

    "export.title": "Export book",
    "export.epub": "EPUB3 · e-Reader",
    "export.pdf": "PDF · Print A5",
    "export.epubDesc": "Standard format for Kindle, Kobo and Apple Books.",
    "export.pdfDesc": "A5 layout ready for print or review.",
    "export.download": "Download",
    "export.preparing": "Preparing file…",

    "toast.saved": "Changes saved",
    "toast.aiDone": "Text generated",
    "toast.coverApplied": "Cover applied",
    "toast.exported": "Book exported",
    "toast.error": "An error occurred",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("eneser_lang") || "es");
  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("eneser_lang", l);
  }, []);
  const t = useCallback((key) => translations[lang][key] ?? translations.es[key] ?? key, [lang]);
  return <I18nContext.Provider value={{ lang, changeLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
